<template>
  <div>
      <iframe :src=url_notion style="position:fixed; top:100px; left:0px; bottom:0px; right:0px; width:100%; height:100%; border:none; margin:0; padding:0; overflow:hidden; z-index:999999;"/>
</div>
</template>

<script>
import Layout from '@/Shared/Layout'



export default {
  metaInfo: { title: 'Entretaiments' },
  components: {
  },
  layout: Layout,
  props: {
    url_notion: String,
  },
  mounted(){
  },
data () {
      return {
      }
    },
  }
</script>
<style>
  .small {
    max-width: 300px;
    margin:  10px auto;
  }
</style>